import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrbit = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 3,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0002 4C14.1217 4.00006 16.1563 4.84277 17.6565 6.34277C19.1568 7.84306 20.0002 9.87827 20.0002 12H18.0002C18.0002 10.4088 17.3676 8.88302 16.2424 7.75781C15.1173 6.63265 13.5915 6.00006 12.0002 6C10.4089 6 8.8823 6.63259 7.75708 7.75781C7.43114 8.08381 7.14624 8.4431 6.90649 8.82812L5.20923 7.77148C5.52909 7.25777 5.90828 6.77752 6.34302 6.34277L6.6311 6.06934C8.09858 4.74075 10.0113 4 12.0002 4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 15L15.9999 11.9999L22.0001 11.9999L19 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 20C9.8783 20 7.84304 19.1575 6.34277 17.6572C4.84251 16.1569 4 14.1217 4 12L6 12C6 13.5913 6.63262 15.117 7.75781 16.2422C8.88301 17.3674 10.4087 18 12 18C13.4918 18 14.9267 17.4448 16.0273 16.4482L16.2432 16.2422C16.5918 15.8935 16.8928 15.5064 17.1426 15.0908L18.8574 16.1211C18.5242 16.6756 18.1222 17.1922 17.6572 17.6572L17.3691 17.9307C15.9017 19.2593 13.989 20 12 20Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.00024 9L8.00036 12.0001H2.00013L5.00024 9Z",
			fill: "currentColor"
		})
	]
});
export default SvgOrbit;
